export function Close() {
  return (
    <path
      fill="currentColor"
      d="M27.685 24.084l19.551-19.55c1.019-1.017 1.019-2.67 0-3.686-1.018-1.018-2.667-1.018-3.685 0L24 20.4 4.449.85C3.431-.172 1.782-.172.764.848c-1.019 1.016-1.019 2.668 0 3.685l19.55 19.55L.765 43.635c-1.019 1.017-1.019 2.67 0 3.686.509.509 1.176.763 1.843.763s1.333-.254 1.842-.763L24 27.77l19.551 19.55c.51.51 1.176.764 1.844.764.667 0 1.332-.254 1.841-.763 1.019-1.017 1.019-2.669 0-3.686l-19.55-19.55"
    />
  )
}
